import { Input, TextArea } from 'components'
import s from './styles.module.scss'
import { clampField, limitHint } from './limits'

export const CharCount = ({ value = '', spec }) => {
  const str = typeof value === 'string' ? value : ''
  const len = str.length
  const max = spec?.max ?? spec?.perLine ?? 0
  const over = spec?.perLine != null
    ? str.split('\n').length > spec.maxLines || str.split('\n').some(l => l.length > spec.perLine)
    : len > max
  return (
    <span className={over ? s.charCountOver : s.charCount}>
      {len}/{max}{spec?.perLine != null ? ` · ${spec.maxLines} lines max` : ''}
    </span>
  )
}

export const LimitedInput = ({ spec, value, onChange, ...props }) => (
  <div className={s.limitedField}>
    <Input.Classic
      {...props}
      value={value || ''}
      maxLength={spec?.max}
      onChange={e => onChange(clampField(e.target.value, spec))}
    />
    <div className={s.limitRow}>
      <span className={s.limitHint}>{limitHint(spec)}</span>
      <CharCount value={value} spec={spec} />
    </div>
  </div>
)

export const LimitedTextArea = ({ spec, value, onChange, ...props }) => (
  <div className={s.limitedField}>
    <TextArea.Classic
      {...props}
      value={value || ''}
      maxLength={spec?.max}
      onChange={e => onChange(clampField(e.target.value, spec))}
    />
    <div className={s.limitRow}>
      <span className={s.limitHint}>{limitHint(spec)}</span>
      <CharCount value={value} spec={spec} />
    </div>
  </div>
)
